import React from 'react';
import Cookies from "js-cookie"
import 'semantic-ui-css/semantic.min.css'
import {Container, Divider, Grid} from 'semantic-ui-react'
import {withRouter} from 'react-router-dom'
import NavBar from '../NavBar'
import NewModal from '../AdminControls/NewModal'
import Footer from '../Utils/Footer'
import ListObj from '../AdminControls/ListObj'
import PipelineMod from '../AdminControls/Pipeline/PipelineMod';


class Pipelines extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      loading: true,
      token: JSON.parse(
        Cookies.get("deepstain-access")).token,
      profileControl: false
    }
    window.document.body.style.overflow = "hidden"
  }

  toggleProfileControl = () => {
    const {profileControl} = this.state;
    this.setState({profileControl: !profileControl})
  }


  render () {
    const {profileControl} = this.state;
    const routeName = "pipelines";
    const panelsOff = e => {
      this.setState({
        profileControl: false})
    }
    return (
      <div>
        <NavBar
          profileControl={profileControl} 
          toggleProfileControl={this.toggleProfileControl} />
        {<div>
          <Container
            blurring 
            fluid
            onClick={panelsOff}
            style={{ 
              paddingLeft: '0.5vh', 
              height: '82vh'}}>
              <div style={{padding:'4vh'}}>
              <NewModal 
                  obj_name={"Pipelines"}
                  route_obj={routeName}/>
              </div>
              <Grid columns={2}>
                <Grid.Row>
                  <Grid.Column>
                    <ListObj 
                      obj_route={routeName}
                      results={true}/>
                  </Grid.Column>
                  <Grid.Column>
                    <PipelineMod 
                      obj_route={routeName}
                      results={true}/>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Divider/>
          </Container>
          <Footer/>
        </div>}
      </div>
    );
  }
}

export default withRouter(Pipelines);
